import { IconProps } from "../../icons/dto";

export function Sort(props: IconProps) {
    const { size, color } = props;
    return (
        <svg width={size ?? "12"} height={size ?? "12"} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_2346_9549" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
                <path d="M0 0H12V12H0V0Z" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_2346_9549)">
                <path d="M4 6.50006V2.91256L2.7125 4.20006L2 3.50006L4.5 1.00006L7 3.50006L6.2875 4.20006L5 2.91256V6.50006H4ZM7.5 11.0001L5 8.50006L5.7125 7.80006L7 9.08756V5.50006H8V9.08756L9.2875 7.80006L10 8.50006L7.5 11.0001Z" fill={color ?? "#B3B8C6"} />
            </g>
        </svg>
    )
}